@if (!item.subItems) {
  @if (!item.isNavButton) {
    <ng-template
      [ngTemplateOutlet]="navLink"
      [ngTemplateOutletContext]="{ item: item }"
    ></ng-template>
  }
  @if (item.isNavButton) {
    <ng-template
      [ngTemplateOutlet]="navButton"
      [ngTemplateOutletContext]="{ item: item }"
    ></ng-template>
  }
} @else {
  <mat-expansion-panel class="nav-menu-panel mat-elevation-z0">
    <mat-expansion-panel-header [attr.data-testid]="getDataTestId(item.text)">
      <mat-panel-title class="nav-menu-panel-title">
        <emperor-icon [name]="item.icon ?? ''" class="nav-icon"></emperor-icon>
        {{ item.text }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    @for (subItem of item.subItems; track subItem) {
      @if (!subItem.isNavButton) {
        <ng-template
          [ngTemplateOutlet]="navLink"
          [ngTemplateOutletContext]="{ item: subItem }"
        ></ng-template>
      }
      @if (subItem.isNavButton) {
        <ng-template
          [ngTemplateOutlet]="navButton"
          [ngTemplateOutletContext]="{ item: subItem }"
        ></ng-template>
      }
    }
  </mat-expansion-panel>
}

<ng-template #navButton let-item="item">
  <emperor-nav-button
    class="nav-menu-item"
    [routerLink]="item.url"
    [highlight]="false"
    [stopPropagation]="false"
    [attr.data-intercom-target]="getIntercomTarget(item.text)"
    [attr.data-testid]="getDataTestId(item.text)"
    (click)="onClick(item)"
    [disabled]="item.disabled"
    tabindex="-1"
  >
    <emperor-icon name="{{ item.icon }}" class="nav-icon"></emperor-icon>
    {{ item.text }}
  </emperor-nav-button>
</ng-template>

<ng-template #navLink let-item="item">
  @if (item.action) {
    <a
      emperor-nav-link
      class="nav-menu-item"
      [attr.data-intercom-target]="getIntercomTarget(item.text)"
      [attr.data-testid]="getDataTestId(item.text)"
      [rounded]="false"
      tabindex="0"
      (click)="onClick(item)"
      (keydown.enter)="onClick(item)"
    >
      <emperor-icon [name]="item.icon" class="nav-icon"></emperor-icon>
      {{ item.text }}
    </a>
  }
  @if (item.url) {
    <a
      emperor-nav-link
      class="nav-menu-item"
      [attr.data-intercom-target]="getIntercomTarget(item.text)"
      [attr.data-testid]="getDataTestId(item.text)"
      [routerLink]="item.url"
      [rounded]="false"
      (click)="onClick(item)"
    >
      <emperor-icon [name]="item.icon" class="nav-icon"></emperor-icon>
      {{ item.text }}
    </a>
  }
  @if (item.externalUrl) {
    <a
      emperor-nav-link
      class="nav-menu-item"
      [attr.data-intercom-target]="getIntercomTarget(item.text)"
      [attr.data-testid]="getDataTestId(item.text)"
      [href]="item.externalUrl"
      [rounded]="false"
      (click)="onClick(item)"
      target="_blank"
    >
      <emperor-icon [name]="item.icon" class="nav-icon"></emperor-icon>
      {{ item.text }}
    </a>
  }
</ng-template>
